// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SVGWrapper } from '../../../../../../svg-wrapper/svg-wrapper';
export const ProfileOption = ({ title, svg, onClick, type = 'option', disabled, }) => {
    return (React.createElement("div", { className: `profile-menu-option_item ${type} ${!!disabled ? 'disabled' : ''}`, onClick: () => {
            if (!disabled) {
                onClick();
            }
        } },
        React.createElement(SVGWrapper, { svg: svg }),
        React.createElement("span", null, title)));
};
//# sourceMappingURL=profile-option.js.map